export const formatForUrl = (text) => {
  if (!text) return "";
  let slug = text.toLowerCase();
  slug = slug.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  slug = slug.replace(/\s+/g, "_");
  slug = slug.replace(/[^a-z0-9_]/g, "");
  slug = slug.replace(/^_+|_+$/g, "");
  return slug;
};